import React, { useEffect, useState } from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Navbar,
} from "reactstrap";

// core components
import useWindowSize from "../useWindowSize"
import NavItems from "./NavItems";

function ColorNavbar({ changing = true }) {
  const [navbarColor, setNavbarColor] = useState("navbar-transparent");
  const [bodyClick, setBodyClick] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const { height } = useWindowSize()

  useEffect(() => {

    // See documentation here: https://wicky.nillia.ms/headroom.js/
    // TOOK ME FOREVER TO FIND IT
    const options = {
      classes: {
        unpinned: "headroom--unpinned"
      }
    }

    let headroom = new Headroom(document.getElementById("navbar-main"), options);

    // initialise
    headroom.init();
    const updateNavbarColor = () => {
      if (
        (document.documentElement.scrollTop > height / 3 ||
          document.body.scrollTop > height / 3) && changing
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < height / 3 ||
        document.body.scrollTop < height / 3
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  return (
    <>
      {bodyClick ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar
        style={{
          WebkitTransition: 'all .5s ease-in-out'
        }}
        disableinlinestyles="true"
        className={classnames("fixed-top", navbarColor,)}
        expand="lg"
        id="navbar-main"
      >
        <NavItems
          collapseOpen={collapseOpen}
          setBodyClick={setBodyClick}
          setCollapseOpen={setCollapseOpen}
        />
      </Navbar>
    </>
  );
}

export default ColorNavbar;
